export default "__VITE_ASSET__CJqLlDrV__"